import { createAction } from 'redux-actions';

export const setOrganization = createAction('SET_ORGANIZATION');
// export const setSuOrganization = createAction('SET_SU_ORGANIZATION'); //SuperAdmin filter